<template>
  <el-drawer
    :title="title"
    :visible.sync="visible"
    :direction="direction"
    :size="size"
    :before-close="handleClose"
  >
    <slot v-if="visible" />
  </el-drawer>
</template>

<script>
export default {
  name: 'Drawer',
  props: {
    visible: {
      type: Boolean,
      deafult: false
    },
    direction: {
      type: String,
      default: 'rtl'
    },
    title: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '40%'
    }
  },
  methods: {
    handleClose() {
      this.$emit('closeDrawer', false)
    }
  }
}
</script>
